import {  Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import {NavigationEnd, Router } from '@angular/router';
import { LocalstorageService } from './localstorage.service';
import { GlobalEventMangerService } from './global-event-manger.service';

@Component({
  selector: 'echexpayment-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'eChex Payment';
  timer = 0;
  interval: any; // Moved it out.

  constructor(private router: Router, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService, private renderer: Renderer2) {}

  ngOnInit() {
    setInterval(() => {
      let clearTimer = localStorage.getItem('time-limit'); 
      if (clearTimer == 'clear-now') {
        this.timer = 0;
        setTimeout(() => {
          localStorage.removeItem('time-limit');
        }, 5000);
      } else {
        this.timer++;

        if (this.timer > 14400) {
          this.localStorageService.removeData('currentUser');
          this.localStorageService.removeData("Profile_image")
          this.localStorageService.removeData('Mer_Profile_image');
          this.globalEventMangerService.ghostLogin(false);
          this.localStorageService.removeData('merchantAdmin');
          this.localStorageService.removeData('currentUserToken');
          this.localStorageService.removeData('super_admin_token');
          this.localStorageService.removeData('super_admin_detail');
          this.globalEventMangerService.showNavBar(false);
          this.router.navigate(['/login']);
          location.reload();
          // this.localStorageService.setData("currentUser", '');
          // this.router.navigate(['/login']);
          return false;
        }
      }
    }, 1000);
  }

  @HostListener('window:mousemove', ['$event']) mousemove(event: KeyboardEvent) {
    this.timer = 0;
    localStorage.setItem('time-limit', "clear-now");
  }

  @HostListener('window:mouseup', ['$event']) mouseup(event: KeyboardEvent) {
    this.timer = 0;
    localStorage.setItem('time-limit', "clear-now");
  }

  @HostListener('window:keydown', ['$event']) handleKeyDown(event: KeyboardEvent) {
    this.timer = 0;
    localStorage.setItem('time-limit', "clear-now");
  }  

  // @HostListener('window:load') onLoad() {
  //   let loader = this.renderer.selectRootElement('.loader');
  //   this.renderer.setStyle(loader, 'display', 'none');
  // }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/app.component.ts